import { Mixpanel } from '../services/Mixpanel';
import { openQuotaUpgrade } from '../utils/openQuotaUpgrade';

// Marketing-site explainer for the regional weekly limit.
export const QUOTA_LEARN_MORE_URL = 'https://web.diffit.me/regional-weekly-resource-limits';

/** Inline upgrade link shared by the quota surfaces. */
// Color is its own prop: a text color passed via className would lose to these on stylesheet order.
export const ProjectQuotaUpgradeLink = ({
  location,
  quota,
  children,
  className = '',
  colorClassName = 'text-emerald-700 hover:text-emerald-800',
}) => (
  <button
    type='button'
    onClick={() => openQuotaUpgrade(location, quota)}
    className={`font-medium hover:underline ${colorClassName} ${className}`}>
    {children}
  </button>
);

/** Inline link to the regional-limit explainer, tracked like the upgrade link but styled quieter. */
export const ProjectQuotaLearnMoreLink = ({
  location,
  quota,
  children = 'Learn more',
  className = '',
  colorClassName = 'text-gray-500 hover:text-gray-700',
}) => (
  <a
    href={QUOTA_LEARN_MORE_URL}
    target='_blank'
    rel='noopener noreferrer'
    onClick={() =>
      Mixpanel.track('Project Quota Learn More Clicked', {
        location,
        remaining: quota?.remaining,
        limit: quota?.limit,
      })
    }
    className={`underline ${colorClassName} ${className}`}>
    {children}
  </a>
);
